const defaultApiRoute = "https://backend.elretodekike.com/api";

export default {
    defaultApiRoute: defaultApiRoute,
};
